/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfilePreviewResponse
 */
export interface StoreProfilePreviewResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfilePreviewResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePreviewResponse
     */
    link: string;
}

/**
 * Check if a given object implements the StoreProfilePreviewResponse interface.
 */
export function instanceOfStoreProfilePreviewResponse(value: object): value is StoreProfilePreviewResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('link' in value) || value['link'] === undefined) return false;
    return true;
}

export function StoreProfilePreviewResponseFromJSON(json: any): StoreProfilePreviewResponse {
    return StoreProfilePreviewResponseFromJSONTyped(json, false);
}

export function StoreProfilePreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfilePreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'link': json['link'],
    };
}

export function StoreProfilePreviewResponseToJSON(json: any): StoreProfilePreviewResponse {
    return StoreProfilePreviewResponseToJSONTyped(json, false);
}

export function StoreProfilePreviewResponseToJSONTyped(value?: StoreProfilePreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'link': value['link'],
    };
}

